import type { components } from "@dolfin/api-admin";
import { BillsTable } from "@/components/BillsTable";
import { RecordListFilterBar, useRecordListFilters } from "@/components/RecordListFilters";

type BillState = components["schemas"]["BillState"];

// In lifecycle order; the Record type makes this exhaustive (a new BillState is a compile error).
const STATE_LABELS: Record<BillState, string> = {
  Created: "Created",
  OcrProcessing: "OCR processing",
  OcrFailed: "OCR failed",
  Extracting: "Extracting",
  ExtractionFailed: "Extraction failed",
  PendingReview: "Pending review",
  NeedsApproval: "Needs approval",
  Approved: "Approved",
  Rejected: "Rejected",
  Scheduled: "Scheduled",
  PaymentInProgress: "Payment in progress",
  PaymentFailed: "Payment failed",
  PartiallyPaid: "Partially paid",
  Paid: "Paid",
  Voided: "Voided",
};

export function BillsPage() {
  const { values, bar } = useRecordListFilters({ states: STATE_LABELS, textParam: "invoiceNumber" });

  return (
    <div className="mx-auto w-full max-w-[100rem] p-8">
      <h1 className="mb-1 text-2xl font-bold">Bills</h1>
      <p className="mb-6 text-sm text-muted-foreground">Bills across all organisations, newest first.</p>

      <RecordListFilterBar filters={bar} textPlaceholder="Filter by invoice number..." dateLabel="Invoice date" />

      <BillsTable
        organisationId={values.organisationId}
        filters={{
          states: values.state ? [values.state] : undefined,
          invoiceNumber: values.text,
          invoiceDateFrom: values.from,
          invoiceDateTo: values.to,
        }}
      />
    </div>
  );
}
